import { useTrainingAccess } from '../resilience/hooks/useTrainingAccess';
import { Training } from './Training';

export const TrainingForCustomer = () => {
  const trainingAccess = useTrainingAccess();

  return <Training trainingAccess={trainingAccess} />;
};
